var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotionDetectionOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3349 8.66113V7.3278H13.9616C13.6549 4.5478 11.4483 2.34113 8.66828 2.03447V0.661133H7.33495V2.03447C6.68161 2.1078 6.06161 2.2878 5.48828 2.55447L6.50828 3.57447C6.97495 3.41447 7.48161 3.3278 8.00161 3.3278C10.5816 3.3278 12.6683 5.41447 12.6683 7.99446C12.6683 8.52113 12.5816 9.02113 12.4216 9.4878L13.4416 10.5078C13.7083 9.93446 13.8883 9.31446 13.9616 8.66113H15.3349Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00155 2.84039L2.94155 1.90039L14.0949 13.0537L13.1549 13.9937L11.7949 12.6337C10.9215 13.3471 9.84821 13.8204 8.66821 13.9537V15.3271H7.33488V13.9537C4.55488 13.6471 2.34821 11.4404 2.04155 8.66039H0.668213V7.32706H2.04155C2.17488 6.14706 2.64821 5.07372 3.36155 4.20039L2.00155 2.84039ZM3.3354 7.99289C3.3354 10.5729 5.42207 12.6596 8.00207 12.6596C9.0754 12.6596 10.0621 12.2929 10.8487 11.6862L4.30873 5.14622C3.70207 5.93289 3.3354 6.91956 3.3354 7.99289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionDetectionOff);
export default __webpack_public_path__ + "static/media/motion-detection-off.d2943c26.svg";
export { ForwardRef as ReactComponent };